export * from './poi-button.component';
export * from './poi-dialog.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/poi-button/index.ts